import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-mwc-burgundy text-white pt-12 pb-6" data-id="element-127">
      <div className="container mx-auto px-4" data-id="element-128">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-129">
          {/* Company Information */}
          <div data-id="element-130">
            <div className="mb-4" data-id="element-131">
              <Logo data-id="element-132" />
            </div>
            <p className="mb-4 text-gray-300" data-id="element-133">
              Providing professional appliance repair and maintenance services
              across the UK. Our expert engineers are ready to help keep your
              home running smoothly.
            </p>
            <div className="flex space-x-4" data-id="element-134">
              <a href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-135">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-136">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-137" />
                </svg>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-138">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-139">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-140" />
                </svg>
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors" data-id="element-141">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-142">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-143" />
                </svg>
              </a>
            </div>
          </div>
          {/* Contact Information */}
          <div data-id="element-144">
            <h3 className="text-lg font-semibold mb-4" data-id="element-145">Contact Us</h3>
            <ul className="space-y-3" data-id="element-146">
              <li className="flex items-start" data-id="element-147">
                <PhoneIcon className="w-5 h-5 mr-2 mt-0.5 text-mwc-pink" data-id="element-148" />
                <span data-id="element-149">0800 055 4969</span>
              </li>
              <li className="flex items-start" data-id="element-150">
                <MailIcon className="w-5 h-5 mr-2 mt-0.5 text-mwc-pink" data-id="element-151" />
                <span data-id="element-152">support@maplewood-care.com</span>
              </li>
              <li className="flex items-start" data-id="element-153">
                <MapPinIcon className="w-5 h-5 mr-2 mt-0.5 text-mwc-pink" data-id="element-154" />
                <span data-id="element-155">2B Westbury Ave, London, N22 6BS</span>
              </li>
              <li className="flex items-start" data-id="element-156">
                <ClockIcon className="w-5 h-5 mr-2 mt-0.5 text-mwc-pink" data-id="element-157" />
                <div data-id="element-158">
                  <p data-id="element-159">Monday-Friday: 9:00am-7:00pm</p>
                  <p data-id="element-160">Saturday: 9:00am-2:00pm</p>
                  <p data-id="element-161">Sunday: Closed</p>
                </div>
              </li>
            </ul>
          </div>
          {/* Quick Links */}
          <div data-id="element-162">
            <h3 className="text-lg font-semibold mb-4" data-id="element-163">Quick Links</h3>
            <ul className="space-y-2" data-id="element-164">
              <li data-id="element-165">
                <Link to="/" className="text-gray-300 hover:text-white transition-colors" data-id="element-166">
                  Home
                </Link>
              </li>
              <li data-id="element-167">
                <Link to="/service-coverage" className="text-gray-300 hover:text-white transition-colors" data-id="element-168">
                  Service Details
                </Link>
              </li>
              <li data-id="element-169">
                <Link to="/soft-services" className="text-gray-300 hover:text-white transition-colors" data-id="element-170">
                  Soft Service Guides
                </Link>
              </li>
              <li data-id="element-171">
                <Link to="/about-us" className="text-gray-300 hover:text-white transition-colors" data-id="element-172">
                  About Us
                </Link>
              </li>
              <li data-id="element-173">
                <Link to="/contact-us" className="text-gray-300 hover:text-white transition-colors" data-id="element-174">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-175">
                <Link to="/faq" className="text-gray-300 hover:text-white transition-colors" data-id="element-176">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
          {/* Legal Terms */}
          <div data-id="element-177">
            <h3 className="text-lg font-semibold mb-4" data-id="element-178">Legal Terms</h3>
            <ul className="space-y-2" data-id="element-179">
              <li data-id="element-180">
                <Link to="/cancellation-policy" className="text-gray-300 hover:text-white transition-colors" data-id="element-181">
                  Cancellation Terms
                </Link>
              </li>
              <li data-id="element-182">
                <Link to="/refund-policy" className="text-gray-300 hover:text-white transition-colors" data-id="element-183">
                  Refund Terms
                </Link>
              </li>
              <li data-id="element-184">
                <Link to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors" data-id="element-185">
                  Privacy & Cookie Notice
                </Link>
              </li>
              <li data-id="element-186">
                <Link to="/terms-conditions" className="text-gray-300 hover:text-white transition-colors" data-id="element-187">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/* Payment Methods */}
        <div className="mb-6" data-id="element-188">
          <h3 className="text-lg font-semibold mb-3" data-id="element-189">Payment Methods</h3>
          <div className="flex space-x-4" data-id="element-190">
            <div className="bg-white p-2 rounded" data-id="element-191">
              <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@develop/icons/visa.svg" alt="Visa" className="h-8 w-auto" data-id="element-192" />
            </div>
            <div className="bg-white p-2 rounded" data-id="element-193">
              <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@develop/icons/mastercard.svg" alt="Mastercard" className="h-8 w-auto" data-id="element-194" />
            </div>
            <div className="bg-white p-2 rounded" data-id="element-195">
              <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@develop/icons/paypal.svg" alt="PayPal" className="h-8 w-auto" data-id="element-196" />
            </div>
            <div className="bg-white p-2 rounded" data-id="element-197">
              <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@develop/icons/shopify.svg" alt="Shop Pay" className="h-8 w-auto" data-id="element-198" />
            </div>
          </div>
        </div>
        {/* Copyright */}
        <div className="border-t border-gray-700 pt-6 text-center text-gray-400 text-sm" data-id="element-199">
          <p data-id="element-200">
            &copy; {new Date().getFullYear()} Maplewood-Care. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;